import { Component, Input, OnInit, ChangeDetectorRef, Output, EventEmitter, Inject, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputOtpModule } from 'primeng/inputotp';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_CONFIG, AppConfig } from '@oneqrew-partnertool/config';
@Component({
  selector: 'order-app-access-dialog',
  standalone: true,
  imports: [FormsModule, InputOtpModule, SharedModule, ButtonModule, CommonModule],
  templateUrl: './order-app-access-dialog.component.html',
  styleUrls: ['./order-app-access-dialog.component.scss']
})
export class OrderAppAccessDialogComponent implements OnInit {
  class = 'order-app-access-dialog';
  @Input() customerOfferId!: number;
  @Output() closeDialog = new EventEmitter<void>();
  accessCode!: string;
  invalidCode: boolean = false;
  isVerifying: boolean = false;

  constructor(private cdr: ChangeDetectorRef, private http: HttpClient, @Inject(APP_CONFIG) private config: AppConfig) {}

  ngOnInit(): void {}

  verifyAccess(): void {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };

    this.http.post<string>(`${this.config.landingPage.apiURL}/access-order-app/`, this.accessCode, httpOptions).subscribe({
      next: (verified) => {
        this.isVerifying = false;
        if (verified) {
          this.closeDialog.emit();
        } else {
          this.isVerifying = false;
          this.invalidCode = true;
        }
      },
      error: () => {
        this.isVerifying = false;
        this.invalidCode = true;
      }
    });
  }
}
